import { useQuery } from '@tanstack/react-query'
import { fromHouseConsignmentDetailsResponse } from '../models/mapper'
import { HouseConsignmentDetails } from '../models/types'
import { fetchHouseConsignmentV3 } from './http'

export async function fetchHouseConsignment(id: number, opts?: { signal?: AbortSignal }): Promise<HouseConsignmentDetails> {
  const response = await fetchHouseConsignmentV3(id, opts)
  return fromHouseConsignmentDetailsResponse(response)
}

export function useFetchHouseConsignment(id: number | null) {
  return useQuery({
    queryKey: ['v3/house-consignment', id],
    queryFn: ({ signal }) => fetchHouseConsignment(id as number, { signal }),
    enabled: !!id,
  })
}
